import { lazyGetItemProperties } from 'owa-get-item-manager';
import { featureId } from '../utils/userHighlightItemPropertyEntry';
import { ClientItem } from 'owa-mail-store';
import Item from 'owa-service/lib/contract/Item';
import { mutatorAction } from 'satcheljs';

export default async function initUserHighlightDataForItem(item: ClientItem) {
    const itemUserHighlights = (await loadUserHighlightDataForItem(item)) || [];
    setUserHighlightDataForItem(item, itemUserHighlights);
}

async function loadUserHighlightDataForItem(item: ClientItem): Promise<string[]> {
    let updatedItem: Item = null;

    try {
        const getItemProperties = await lazyGetItemProperties.import();
        updatedItem = await getItemProperties(item.ItemId.Id, featureId);
    } catch (e) {
        // On a network error we just won't have highlight data for this item
    }

    if (updatedItem) {
        return updatedItem.UserHighlightData;
    }

    return null;
}

const setUserHighlightDataForItem = mutatorAction(
    'setUserHighlightDataForItem',
    (item: ClientItem, userHighlightData: string[]) => {
        item.userHighlightData = userHighlightData;
    }
);
